import React, { useState, useEffect } from "react";
import { environment } from "../../environment";
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import Container, { TableContainer, TextField } from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const BoxCategory = ({ history }) => {
  const [show, setShow] = useState(false);
  const [category, setCategory] = useState("");
  const [description, setdescription] = useState("");
  const [productcategories, setproductcategories] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [categorynameErrors, setCategoryNameErrors] = useState({});
  const [displayErr, setDisplayErr] = useState("none");
  const [isRepeatBox, setIsRepeatBox] = useState(false);

  const handleClose = () => {
    setShow(false);
    setCategoryNameErrors({});

    setCategory("");
    setIsChecked(false);
  };
  const handleShow = () => setShow(true);
  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const deleteHandler = (id) => {
    alert(id);
    // delete the device from database

    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "boxApi/deleteById?_id=" + id)
          .then(async (res) => {
            MySwal.fire({
              title: <p>Box category has been deleted!</p>,
              type: "success",
            });
            getAllCategory();
          })
          .catch((err) => {
            console.log(err);
            MySwal.fire({
              title: (
                <p>{err?.response?.data?.message || "Something went wrong!"}</p>
              ),
              type: "error",
            });
          });
      }
    });
  };
  const viewHandler = (id) => {
    alert(id);
  };
  const formValidation = () => {
    // const duplicateEntry = {};
    let isValid = true;
    if (category == "") {
      isValid = false;
    }
    console.log(isValid);
    return isValid;
  };

  const isDuplicate = async () => {
    let isRepeat = true;
    await axios
      .post(environment.dap_url + "boxApi/checkDuplicate", {
        boxCategoryName: category,
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.status == false) {
          isRepeat = true;
          return true;
        } else {
          isRepeat = false;
          return false;
        }

        console.log(isRepeat);
      });
    // return isRepeat;
  };

  const handleInputChange = (event) => {
    const newInputValue = event.target.value;
    // setInputValue(newInputValue);
    setCategory(newInputValue)
   axios .post(environment.dap_url + "boxApi/checkDuplicate", {
      boxCategoryName: newInputValue,
    })
    .then((response) => {
      console.log(response.data.status)
      if(response.data.status == false){
        // isRepeat=true
        setIsRepeatBox(true);
        setDisplayErr("block");
        categorynameErrors.noName = "* Duplicate Entry";
        setCategoryNameErrors(categorynameErrors);
      }else{
        // isRepeat = false
        setIsRepeatBox(false);
        setDisplayErr("none");
        setCategoryNameErrors({});
      }
    })
      
  }



  // const isRepeat = false;
  const formsubmit = (e) => {
    const isValid = formValidation();
    // const isRepeat = isDuplicate();
    // alert(isValid);
    // alert(isRepeat);
    console.log(isValid);
    console.log(isRepeatBox);

    const categorynameErrors = {};
    if (isValid == false) {
      categorynameErrors.noName = "* This Field is required";
      setCategoryNameErrors(categorynameErrors);
    } else if (isRepeatBox == true) {
      // alert(1);
      categorynameErrors.noName = "* Duplicate Entry";
      setCategoryNameErrors(categorynameErrors);
    } else if (isRepeatBox == true) {
      alert(1);
      categorynameErrors.noName = "* New Entry";
      setCategoryNameErrors(categorynameErrors);
    }
    if (isRepeatBox == false) {
      // if (isValid && isRepeat) {
      // else {
      axios
        .post(environment.dap_url + "boxApi/AddBoxCategory", {
          boxCategoryName: category,
          notes: description,
        })
        .then((res) => {
          MySwal.fire({
            title: <p>Box Category has been successfully created!</p>,
            type: "success",
          });
          setCategory("");
          setdescription("");
          getAllCategory();
          handleClose();
        });
      // }
      // }
    }

    //  else {
    //   console.log("new entry");
    // }

    // alert(isValid);
    // alert(isRepeat);
    // const isValid = 1;
    // alert(description);
    // console.log(boxCategoryName);
    console.log(category);

    // if (isValid && isRepeat) handleClose();

    // console.log(boxCategoryName);

    // if (isValid == true && isRepeat == false) {
    //   axios
    //     .post(environment.dap_url + "boxApi/AddBoxCategory", {
    //       boxCategoryName: category,
    //       notes: description,
    //     })
    //     .then((res) => {
    //       MySwal.fire({
    //         title: <p>Box Category has been successfully created!</p>,
    //         type: "success",
    //       });
    //       setCategory("");
    //       setdescription("");
    //       getAllCategory();
    //     });
    // }
  };
  const getAllCategory = () => {
    axios
      .get(environment.dap_url + "boxApi/getAllBoxCategory")
      .then((res) => {
        setproductcategories(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    axios
      .get(environment.dap_url + "boxApi/getAllBoxCategory")
      .then((res) => {
        setproductcategories(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const columns = [
    {
      dataField: "sl.no",
      text: "Sl no.",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "boxCategoryName",
      text: "Name",
      sort: true,
    },
    {
      dataField: "notes",
      text: "Description",
      sort: true,
    },
    // {
    //   dataField: "isAccessoriesIncluded",
    //   text: "Accessories Included",
    //   sort: true,
    //   formatter: (dataField) => {
    //     return dataField ? "YES" : "No";
    //   },
    // },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            {/* <Button
              variant="primary"
              className="btn-sm"
              onClick={() => viewHandler(dataField)}
            >
              View <i className="fa fa-eye"></i>
            </Button> */}
            <Button
              variant="danger"
              className="btn-sm"
              onClick={() => deleteHandler(dataField)}
            >
              Delete <i className="fa fa-trash-o"></i>
            </Button>
          </div>
        );
      },
    },
    ,
  ];

  const defaultSorted = [
    {
      dataField: "createdAt",
      order: "asc",
    },
  ];
  return (
    <>
      <div className="row" style={{ marginTop: "72px" }}>
        <div className="col-lg-12">
          <Button
            variant="primary"
            style={{
              float: "right",
              marginBottom: "10px",
              marginRight: "10px",
            }}
            onClick={handleShow}
          >
            Add Box Category
          </Button>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Box Category</h4>
                <div className="row">
                  <div className="col-12">
                    <ToolkitProvider
                      keyField="id"
                      bootstrap4
                      data={productcategories}
                      columns={columns}
                    >
                      {(props) => (
                        <div>
                          <div className="d-flex align-items-center">
                            <p className="mb-2 mr-2">Search in table:</p>
                            <SearchBar {...props.searchProps} />
                          </div>
                          <BootstrapTable
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory()}
                            {...props.baseProps}
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Box Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label> Box Category Name</Form.Label>
            <Form.Control
              type="text"
              //value={deviceData.accessToken}
              placeholder="Category"
              onChange={(e) => handleInputChange(e)}
            ></Form.Control>
            <p  style={{ color: "red",display: displayErr }}>* Duplicate Entry</p>
            <div>
              {Object.keys(categorynameErrors).map((key) => {
                console.log(categorynameErrors[key]);
                return (
                  <div style={{ color: "red" }}>{categorynameErrors[key]}</div>
                );
              })}
            </div>
            {/* <div>
              {Object.keys(duplicateEntry).map((key) => {
                return (
                  <div style={{ color: "red" }}>{duplicateEntry[key]}</div>
                );
              })}
            </div> */}
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              type="text"
              //value={deviceData.accessToken}
              placeholder="Description"
              onChange={(e) => setdescription(e.target.value)}
            ></Form.Control>
          </Form.Group>
          {/* <label>
            Is Accessories Included
            <input
              type="checkbox"
              id="topping"
              name="topping"
              value="Paneer"
              checked={isChecked}
              style={{
                float: "right",
                marginLeft: "10px",
                width: "20px",
                height: "20px",
                marginTop: "3px",
              }}
              onChange={handleOnChange}
            />
          </label> */}
          {/* {isChecked ? (
            <TableContainer>
              {inputfields.map((inputField, index) => (
                <div key={index}>
                  <TextField
                    name="CategoryName"
                    label="Name"
                    // variant="filled"
                    style={{
                      margin: 5,
                    }}
                    value={inputField.CategoryName}
                    onChange={(event) => handleChangeInput(index, event)}
                  />

                  <button
                    className="btn btn-danger btn-sm"
                    style={{
                      margin: 10,
                    }}
                    onClick={(e) => handleRemoveClick(index, e)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-dash-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                    </svg>
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    style={{
                      margin: 10,
                    }}
                    onClick={(e) => handleAddClick(e)}
                  >
                    <svg
                      // xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus-circle"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                  </button>
                </div>
              ))}
            </TableContainer>
          ) : (
            ""
          )} */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={formsubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default BoxCategory;
